import NPSComponent from './NPS';

export default NPSComponent;
